<div class="container-all" style="margin: 10px;">
  <div style="margin-bottom: 10px; margin-top: 20px;">
    <button class="margin" type="button" pButton label="Go Back" (click)="goBack()">
    </button>
    <button class="margin" type="button" pButton label="Download Log" (click)="download()" style="float: right;"  pTooltip="Download may take little longer,&#013;Please wait...">
    </button>
    
  </div>
  <div>
    <h3> <u>Job Name</u> : <small>{{this.avtiveJobLog.jobName }}</small>&emsp;&emsp;&emsp;<u>Job User</u> :
      <small>{{this.avtiveJobLog.jobUser }}</small>&emsp;&emsp;&emsp;<u>Job Number</u> :
      <small>{{this.avtiveJobLog.jobNumber }} </small>
    </h3>
  </div>
  <div class="container-all" *ngFor="let joblog of joblogs" style="line-height: 1; font-family: 'Courier New', Courier, monospace;">   
      <span style="margin-left: 2px;white-space: pre-line;line-height: 0.9; font-family: 'Courier New', Courier, monospace;">{{ joblog.messageText }}</span>     
      <span style="margin-left: 25px;white-space: pre-line;line-height: 0.9; font-family: 'Courier New', Courier, monospace;">
      <div style="margin-left: 25px;font-family: 'Courier New', Courier, monospace;">{{ joblog.messageSecondLevelText }}</div> 
      </span> 
  </div>
</div>